$(document).ready(function() {
  // Open/close mobile nav
  $('#menu-icon').click(function(e) {
    e.preventDefault();
    $('#mobile-nav').slideToggle("fast");
  });
  $(".open-country-nav").on('click', function(e){
    e.stopPropagation();
    $("#c-select-pop").toggleClass('open');
  });

  $("body").on('click',function() {
    if($('.selector-popup').hasClass("open")) {
      $("#c-select-pop").removeClass('open');
    }
  });

/* PRESERVE FOR BACKUP
  $(".cycle").each(function(){
     var cycleTimeout = null;
     var cycle_count = 0;
     var cycleItems = $(this).find(".cycle-item");
     var cycleDuration = $(this).data("duration");
     var thisCycle = $(this);
     cycleDuration = cycleDuration ? cycleDuration : 3000;

     function cycle() {
       cycleItems.removeClass("active").eq(cycle_count).addClass("active");
       cycleTimeout = setTimeout(function () {
         cycle_count = ++cycle_count % cycleItems.length;
         cycle();
       }, cycleDuration);
       var currentPosition = cycle_count + 1;
       thisCycle.find(".indicator").html(currentPosition + "/" + cycleItems.length);
     }
     $(this).find(".cycle-previous").click(function () {
       if (cycleTimeout !== null) {
         clearTimeout(cycleTimeout);
       }
       cycle_count = --cycle_count % cycleItems.length;
       cycle();
     });
     $(this).find(".cycle-next").click(function () {
       if (cycleTimeout !== null) {
         clearTimeout(cycleTimeout);
       }
       cycle_count = ++cycle_count % cycleItems.length;
       cycle();
     });

     $(this).find(".lightbox").click(function () {
      clearTimeout(cycleTimeout);
     });

     cycle();
   });
   */

$('.nav-pill-tabs:not(.eld-nav-pill-tabs)').on('click touchend', 'li', function(e) {
	$(this).siblings().removeClass('active');
	$(this).addClass('active');
	});

	$('.nav-pill-tabs:not(.eld-nav-pill-tabs)').on('keypress', 'li', function(e) {
		var key = e.which;
		if (key == 13) {
			$(this).click().blur();
			return false;
			}
		});

$('.list-expandable').on('click', 'li .expandable-header', function() {
	$(this).blur();
	if ($(this).parent().hasClass('expand-content')) {
		$(this).parent().removeClass('expand-content');
		$(this).siblings('.expandable-content').slideToggle(200);
		}
	else {
		$(this).parent().addClass('expand-content');
		$(this).siblings('.expandable-content').slideToggle(200);
		}
	});

	$('.expandable-header').on('keypress', function(e) {
		var key = e.which;
		if (key == 13) {
			$(this).click().blur();
			return false;
		}
	});

$("#country_code").change(function() {
	if ($("#country_code").val() == "US" || $("#country_code").val() == "CA") {
	$("#state_code").prop('disabled', false);
	$("#state_code").prop('required', true);
	$("#state_code").val('');

	} else {
		$("#state_code").prop('disabled', true);
		$("#state_code").prop('required', false);
	}
});

var samsaraLightbox = function(imgSelector) {
	$(imgSelector).click(function(e) {
	e.preventDefault();
	$(this).find('.lightbox-content').toggleClass("show");
	});
};

samsaraLightbox('.lightbox');

	$(document).on('click', 'a.link-anchor-scroll', function(e) {
		event.preventDefault();

		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 480);
	});

	// On click of "Try for Free" button, scroll to form at page bottom
	$('#free-trial-button').on('click touchend', function(e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 480);
	});

	var benefitsFeatures = $('#benefits-features');
	var playButton = $('.play-button');
	var screenContent = $('.screen-content');
	var activeClass = 'active';

	function stopVideos() {
		var allVideos = benefitsFeatures.find('video');
		allVideos.each(function() {
			$(this)[0].pause();
			$(this)[0].currentTime = 0;
			});
		allVideos.siblings('img').show();
		allVideos.removeClass(activeClass);
		allVideos.parent().removeClass(activeClass);
		allVideos.parent().siblings(screenContent).fadeIn(240,'linear');
		}

	// Simulate :active pseudo state
	playButton.on('mousedown mouseup mouseleave', function(e) {
		$(this).toggleClass(activeClass, e.type === 'mousedown').blur();
		});

	playButton.on('click', function() {
		stopVideos();
		$(this).siblings('.video').children('img').hide();
		$(this).addClass(activeClass);
		$(this).siblings(screenContent).addClass(activeClass);
		$(this).fadeOut(240,'linear');
		$(this).siblings('.video').children('video')[0].play();
		});

	screenContent.find('video').on('ended',function() {
		$(this).siblings('img').show();
		$(this).removeClass(activeClass);
		$(this).parent().removeClass(activeClass);
		$(this).parent().siblings(playButton).removeClass(activeClass);
		$(this).parent().siblings(screenContent).fadeIn(240,'linear');
	});

	playButton.on('keypress', function(e) {
		var key = e.which;
		if (key == 13) {
			$(this).click().blur();
			return false;
		}
	});

	function filterPositions () {
		var departmentSelection = $('#careers-departments-filter input:checked').val();
	if($(window).width() < 736){
		departmentSelection = $('#careers-departments-filter-mobile option:checked').val();
	}
		var locationSelection = $('#careers-locations-filter option:checked').val();
		$('.open-positions-list .department').each(function() {
			var department_id = $(this).data('department');
			if (departmentSelection == department_id || departmentSelection == 0) {
				if (locationSelection == 'all') {
					$(this).show();
					$(this).find('.department-positions-list > li').show();
				} else if ( $(this).is(':contains(' + locationSelection + ')') ){
					$(this).show();
					$(this).find('.department-positions-list > li:contains(' + locationSelection + ')').show();
					$(this).find('.department-positions-list > li').not(':contains(' + locationSelection + ')').hide();
				} else {
					$(this).hide();
				}
			} else {
				$(this).hide();
			}
		});

		if($('.department-positions-list > li:visible').length === 0) {
			$('#no-positions').show();
		} else {
			$('#no-positions').hide();
		}
	}
	$('#careers-departments-filter').change( filterPositions );
$('#careers-departments-filter-mobile').change( filterPositions );
	$('#careers-locations-filter').change( filterPositions );

	$( ".modal-window" ).append( "<div class='modal-close'></div>" );
	$('.modal').click(function (e) {
		$(this).addClass('active');
		$('body').toggleClass('modal-open');
	});

	$('.modal-container').click(function (e) {
		e.stopPropagation();
		if (e.target == this) {
			$('.modal').removeClass('active');
			$('body').toggleClass('modal-open');
		}
	});

	$('.modal-window .modal-close').click(function (e) {
		e.stopPropagation();
		$('.modal').removeClass('active');
		$('body').toggleClass('modal-open');
		var modalId = $(this).parents().eq(2).attr('id');
		var videoURL = $('#'+modalId).find('iframe').prop('src');
		videoURL = videoURL.replace("&autoplay=1", "");
		$('#'+modalId).find('iframe').prop('src','');
		$('#'+modalId).find('iframe').prop('src',videoURL);

	});
  //Marketo force column widths

	window.addEventListener('load', function(){
		var companyField = $("#Company").parents(".mktoFormCol");
		var countryField = $("#Country").parents(".mktoFormCol"); 
		var checkboxLabel = $(".mktoCheckboxList").parents(".mktoFieldWrap");
		var checkboxParent = $(".mktoCheckboxList").parents(".mktoFormCol");
		checkboxLabel.addClass('checkbox');
		checkboxParent.addClass('mkto-full-width');
		companyField.addClass('mkto-full-width');
		countryField.addClass('mkto-full-width');
	});
	if ($(".simple-nav.sticky-nav").length > 0) {
		var heightAdjust = 0;
		var screenWidth = 736;
		if ($(window).width() < screenWidth) {
			heightAdjust = 0;
		} else {
			heightAdjust = 0;
		}
		function sticktothetop() {
			let window_top = $(window).scrollTop();
			let body_height = $(".hero").height();
			if (body_height - heightAdjust < window_top) {
			$(".simple-nav.sticky-nav").css({ transform: "translateY(0px)" });
			} else {
			$(".simple-nav.sticky-nav").css({ transform: "translateY(-80px)" });
			}
		}
		$(function() {
			$(window).scroll(sticktothetop);
			sticktothetop();
		});
	}

});
